/* eslint eqeqeq: off */
import React, {Component} from "react";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import Group from "../../../Components/Group";
import './index.css';
import Grid, {GridButton, GridControls, gridDateTime, GridState, GridStates} from "../../../Components/Grid";
import Modal, {ModalContent, ModalControls} from "../../../Components/Modal";
import Resource from "../../../Resource";
import Hospital from "../../../Server/Hospital";
import PropTypes from "prop-types";
import Button from "../../../Components/Control/Button";
import Notif from "../../../Components/Notif";
import {connect} from "react-redux";
import Perms from "../../../Perms";

class ModalRequestDeliveryProducts extends Component {
    constructor(props) {
        super(props);
        props.refer.current = this;


        this.perms = Perms();

        this.state = {
            grid: {
                defaultColDef: {
                    floatingFilter: false
                },
                columnDefs: [{
                    field: 'productNumber',
                    headerName: 'شماره فرآورده',
                    headerTooltip: 'شماره فرآورده',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    filter: 'agTextColumnFilter'
                }, {
                    field: 'productTypeStr',
                    headerName: 'نوع فرآورده',
                    headerTooltip: 'نوع فرآورده'
                }, {
                    field: 'productBloodGroupStr',
                    headerName: 'گروه خونی',
                    headerTooltip: 'گروه خونی ،رآورده',
                    cellClass: row => 'green'
                }, {
                    field: 'collectionDate',
                    headerName: 'تاریخ جمع آوری',
                    headerTooltip: 'تاریخ جمع آوری',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime.bind(this, 'date')
                }, {
                    field: 'productExpireDate',
                    headerName: 'تاریخ انقضا',
                    headerTooltip: 'تاریخ انقضا',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime.bind(this, 'date')
                    // }, {
                    //     field: 'state',
                    //     headerName: 'وضعیت',
                    //     headerTooltip: 'وضعیت',
                    //     pinned: this.props.gridDefaultSettings.pinStatusColumn,
                    //     sortable: false,
                    //     enableRowGroup: false,
                    //     cellRenderer: 'state',
                    //     valueGetter: row => {
                    //         const filters = [row.data.statusStr];
                    //
                    //         switch (row.data.formTypeId) {
                    //             case 1:
                    //                 filters.push('عادی');
                    //                 break;
                    //             case 2:
                    //                 filters.push('اورژانسی');
                    //                 break;
                    //             case 3:
                    //                 filters.push('خون شسته');
                    //                 break;
                    //             case 4:
                    //                 filters.push('اشعه دیده');
                    //                 break;
                    //             case 5:
                    //                 filters.push('اورژانسی از سازمان');
                    //                 break;
                    //             default:
                    //         }
                    //
                    //         return filters;
                    //     }
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: this.props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    minWidth: 150,
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],
                frameworkComponents: {
                    state: row => {
                        return <GridStates>
                            {/*{row.data.statusId === 20 && <GridState theme={'yellow'}>{row.data.statusStr}</GridState>}*/}
                            {/*{row.data.statusId === 24 && <GridState theme={'yellow'}>{row.data.statusStr}</GridState>}*/}
                            {/*{row.data.formTypeId === 1 && <GridState theme={'green'}>عادی</GridState>}*/}
                            {/*{row.data.formTypeId === 2 && <GridState theme={'red'}>اورژانسی</GridState>}*/}
                            {/*{row.data.formTypeId === 3 && <GridState theme={'red'}>خون شسته</GridState>}*/}
                            {/*{row.data.formTypeId === 4 && <GridState theme={'red'}>خون اشعه‌دیده</GridState>}*/}
                            {/*{row.data.formTypeId === 5 && <GridState theme={'red'}>اورژانسی از سازمان</GridState>}*/}
                        </GridStates>;
                    },
                    control: row => {
                        return <GridControls>
                            {<GridButton type={"button"} theme={'add'} icon={Resource.IMAGE.PACK.CHECK.WHITE} title={'تایید'} onClick={this.confirm.bind(this, row.data)}/>}
                            {<GridButton type={"button"} theme={'red'} icon={Resource.IMAGE.PACK.CANCEL.WHITE} title={'حذف'} onClick={this.reject.bind(this, row.data)}/>}
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node)
                        return [{
                            name: 'تایید فرآورده',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.CHECK.BLACK}" alt="">`,
                            action: this.confirm.bind(this, params.node.data),
                            // disabled: !this.Perms[`${Boolean(params.node.data.hospitalRequestId)}${params.node.data.formTypeId}`].CONFIRM
                        }, {
                            name: 'رد فرآورده',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.CANCEL.BLACK}" alt="">`,
                            action: this.reject.bind(this, params.node.data),
                            // disabled: !this.Perms[`${Boolean(params.node.data.hospitalRequestId)}${params.node.data.formTypeId}`].REJECT
                        },
                            'separator',
                            ...params.defaultItems];
                },
                help: _ => {
                    return <div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>وضعیت‌ها:</h3>
                                <p><GridState theme={'yellow'}>در انتظار تحویل درخواست</GridState> درخواست رسیده از بخش در انتظار تحویل می باشد. (بعد از تحویل درخواست بخش اجازه ویرایش درخواست را ندارد.)</p>
                                <p><GridState theme={'yellow'}>در انتظار تعیین گروه خونی</GridState> درخواست رسیده از بخش در انتظار تعیین گروه خونی نمونه بیمار می باشد. (بعد از تعیین گروه خونی نمونه خون بیمار درخواست از لیست انتظار خارج شده و به ککارتابل اصلی منتقل می شود.)</p>
                                <p><GridState theme={'green'}>عادی</GridState> درخواست فرآورده از نوع عادی می باشد.</p>
                                <p><GridState theme={'red'}>اورژانسی</GridState> درخواست فرآورده از نوع اورژانسی می باشد.</p>
                                <p><GridState theme={'red'}>خون شسته</GridState> درخواست فرآورده از نوع خون شسته می باشد.</p>
                                <p><GridState theme={'red'}>خون اشعه‌دیده</GridState> درخواست فرآورده از نوع خون اشعه دیده می باشد.</p>
                                <p><GridState theme={'red'}>اورژانسی از سازمان</GridState> درخواست فرآورده از سازمان با وضعیت اورژانسی می باشد.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>عملیات:</h3>
                                <p><GridButton theme={'view'} title={'مشاهده'}/> در صورت نیاز به مشاهده درخواست می توانید از این طریق اقدام کنید.</p>
                                <p><GridButton theme={'blue'} title={'تایید'} icon={Resource.IMAGE.PACK.CHECK.WHITE}/> جهت صلب دسترسی بخش از ویرایش درخواست بایستی بعد از مشاهده، درخواست تایید شود.</p>
                                <p><GridButton theme={'accept'} title={'تعیین'}/> پس از تعیین گروه خونی از این طریق نسبت به ثبت آن اقدام نمایید تا درخواست به کارتابل اصلی منتقل شود.</p>
                                <p><GridButton theme={'delete'} title={'حذف'}/> در صورتی نیاز به حذف درخواست می توانید از این طریق اقدام نمایید.</p>
                            </div>
                        </div>
                    </div>;
                },
                getRowClass: row => {
                    if (row.data.productStatusId == 3)
                        return 'red';
                    else if (row.data.productStatusId == 2)
                        return 'blue';
                }
            },
            rowData: [],
            selectedRows: [],
            gridContext: null
        };

        this.ref = {
            grid: React.createRef(),
            modal: React.createRef(),
            prompt: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData;
    }

    render() {
        return <React.Fragment>
            <Modal ref={this.ref.modal}
                   name={'ModalRequestDeliveryProducts'}
                   size={'large'}
                   title={'فرآورده‌های ارسال شده بیمارستان'}
                   style={{height: 'calc(100vh - 60)'}}
                   onClose={this.props.onClose}>
                <ModalContent>
                    <Group className={'ModalRequestDeliveryProducts-group fb-20'}>
                        <Grid refer={this.ref.grid } id={'requestDeliveryProducts'} {...this.state.grid} rowData={this.state.rowData} onGridReady={this.gridReadyHandler.bind(this)} onSelectionChanged={this.gridSelectionHandler.bind(this)}/>
                    </Group>
                </ModalContent>
                <ModalControls>
                    <Button refer={this.ref.close} theme={'blue'} className={'mar-4'} onClick={this.confirmAll.bind(this)}>تایید همه فرآورده‌ها</Button>
                    <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
        </React.Fragment>;
    }

    updateGrid() {
        this.ref.grid.current.loading();

        new Promise((resolve, reject) => {
            if (this.state.data.statusId == 65) {
                Hospital.acceptRequestDelivery({hospitalRequestId: this.state.data?.hospitalRequestId})
                    .then(_ => {
                        resolve();
                    })
                    .catch(message => {
                        resolve();
                    });
            } else
                resolve();
        })
            .then(_ => {
                Hospital.requestDeliveryProducts({hospitalRequestId: this.state.data?.hospitalRequestId})
                    .then(list => {
                        this.ref.grid.current.loading(false);

                        this.setState({rowData: list});
                    })
                    .catch(message => {
                        new Notif({message, theme: 'error'}).show();

                        this.close();
                    });
            })
    }

    gridReadyHandler(params) {
        this.updateGrid();

        this.setState({gridContext: params});
    }

    gridSelectionHandler(rows) {
        this.setState({selectedRows: rows});
    }

    close() {
        this.ref.modal.current.close();

        if (this.state.updated)
            this.props.onSuccess();

        this.props.onClose();
    }

    confirm(row, props = {loading: _ => null}) {
        props.loading();

        Hospital.confirmProductInDelivery({
            orgProductId: row?.orgProductId
        }).then(_ => {
            this.updateGrid();

            props.loading(false);
        }).catch(message => {
            new Notif({message, theme: 'error'}).show();

            props.loading(false);
        });
    };

    confirmAll(row, props = {loading: _ => null}) {
        const {state} = this;
        props.loading();

        state.rowData.map(row => {
            Hospital.confirmProductInDelivery({
                orgProductId: row?.orgProductId
            }).then(_ => {
                this.updateGrid();

                props.loading(false);
            }).catch(message => {
                new Notif({message, theme: 'error'}).show();

                props.loading(false);
            });
        });
    };

    modalSuccessHandler() {
        this.setState({updated: true});

        this.updateGrid(true);
    }

    open(data, action) {

        this.setState({
            action,
            data
        });

        this.ref.modal.current.open();
    }

    reject(row, props = {loading: _ => null}) {
        props.loading();

        Hospital.rejectProductInDelivery({
            orgProductId: row?.orgProductId
        }).then(_ => {
            this.updateGrid();

            props.loading(false);
        }).catch(message => {
            new Notif({message, theme: 'error'}).show();

            props.loading(false);
        });
    };
}

const mapStateToProps = state => {
    return {
        gridDefaultSettings: state.grid.defaultSettings
    };
};

export default connect(mapStateToProps)(ModalRequestDeliveryProducts);